var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as _ from "lodash";
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as RelatedCollectionFactory from "../../classes/definitions/relatedCollection/relatedCollection";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import RelatedCollectionsList from '../../components/RelatedCollections/RelatedCollectionsList/RelatedCollectionsList';
import AppRoutes from '../../config/appRoutes';
import RelatedCollectionsReduxProps from "./RelatedCollectionsReduxProps";
var RelatedCollections = /** @class */ (function (_super) {
    __extends(RelatedCollections, _super);
    function RelatedCollections() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.staticPageId = '';
        _this.brandId = '';
        _this.parentId = '-1';
        _this.state = {
            data: []
        };
        _this.getAllRelatedCollections = function () {
            _this.api.getRelatedCollections(_this.parentId)
                .then(function (response) {
                var data = RelatedCollectionFactory.createRelatedCollections(response.data);
                _this.setState({ data: data });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим записите', _this.props.history);
            });
        };
        _this.toNewRelatedCollection = function () {
            _this.props.history.push(AppRoutes.product.path + '/' + _this.parentId + AppRoutes.relatedCollection.path);
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            var data = __spreadArrays(_this.state.data);
            var result = data.find(function (item) {
                return item.Id === id;
            });
            var index = data.indexOf(result);
            data.splice(index, 1);
            _this.setState({ data: data });
        };
        _this.toParentProduct = function () {
            _this.props.history.push(AppRoutes.product.path + '/' + _this.parentId);
        };
        return _this;
    }
    RelatedCollections.prototype.componentDidMount = function () {
        this.parentId = _.get(this.props, 'match.params.id', '-1');
        if (this.parentId !== '-1') {
            this.getAllRelatedCollections();
        }
    };
    RelatedCollections.prototype.render = function () {
        var _this = this;
        var data = this.state.data;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u0421\u0432\u044A\u0440\u0437\u0430\u043D\u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewRelatedCollection, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432 \u0441\u0432\u044A\u0440\u0437\u0430\u043D \u043F\u0440\u043E\u0434\u0443\u043A\u0442"),
                            React.createElement("a", { onClick: this.toParentProduct },
                                React.createElement("i", { className: "fa fa-backward" }),
                                " \u041D\u0430\u0437\u0430\u0434")),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(RelatedCollectionsList, { gridData: data, messages: this.messages, deleteItem: this.deleteItem }))))));
    };
    return RelatedCollections;
}(React.Component));
export default connect(null, RelatedCollectionsReduxProps.mapDispatchToProps)(RelatedCollections);



//////////////////
// WEBPACK FOOTER
// ./src/views/RelatedCollections/RelatedCollections.tsx
// module id = 431
// module chunks = 0